import { render, staticRenderFns } from "./IconQuotation.vue?vue&type=template&id=1fa1449c"
import script from "./IconQuotation.vue?vue&type=script&lang=js"
export * from "./IconQuotation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports